export const getChartStoreData = (state) => state.chartStore.data || {};
